import sxyxRequest from '../../index'

import { Account, ILoginResult, UserInfo } from '@/models/service/user/IUser'
import type { IDataType } from '../../types'

enum LoginAPI {
  AccountLogin = '/api/auth/form', // 用户表单登录
  VerificationCode = '/api/verification/code', // 获取图片验证码
  getUserInfo = '/api/system/user/info', // 用法: role/1/menu
}

export function accountLoginRequest(account: Account) {
  const formData = new FormData()
  for (const key in account) {
    const v = (account as any)[key]
    formData.append(key, v)
  }
  return sxyxRequest.post<IDataType<ILoginResult>>({
    url: LoginAPI.AccountLogin,
    data: formData,
  })
}

export function getVerificationCode() {
  return sxyxRequest.get<IDataType>({
    url: LoginAPI.VerificationCode,
    showLoading: false,
  })
}

/**
 * 获取当前登录用户信息
 */
export function getUserInfo() {
  return sxyxRequest.get<IDataType<UserInfo>>({
    url: LoginAPI.getUserInfo,
    showLoading: false,
  })
}
